import React from 'react'
import { CustomDeckORM, FolderItemORM } from 'src/types/types'
import {
  useDNACustomDeckActions,
  customDeckContextOptions,
  CustomDeckActions,
} from './DNACustomDeck.actions'
import { DNAContextMenu } from '@alucio/lux-ui'
import { useAppSettings } from 'src/state/context/AppSettings'

export interface DNACustomDeckContextMenuProps {
  folderItemORM: FolderItemORM,
  children: React.ReactElement,
  actions?: CustomDeckActions[],
  unavailableContent?: boolean,
}

export const DNACustomDeckContextMenu: React.FC<DNACustomDeckContextMenuProps> = (props) => {
  const {
    folderItemORM,
    actions,
    children,
  } = props

  const { deviceMode, isOnline } = useAppSettings()
  const DNACustomDeckActions = useDNACustomDeckActions()
  const customDeckORM = folderItemORM.relations.item as CustomDeckORM
  const actionsToUse: CustomDeckActions[] = []
  const isDesktop = deviceMode === 'desktop'

  const isReviewRequired: boolean = customDeckORM.meta.version.requiresReview;

  const isOfflineSynced = (!isOnline && customDeckORM.meta.assets.isContentCached)

  // Button permissions
  const canEdit = !isReviewRequired && (isOnline || isOfflineSynced)
  const canDelete = true
  const canAddToFolder = !isReviewRequired
  const canDuplicate = !isReviewRequired
  const canPresent = !isReviewRequired && (isOnline || isOfflineSynced)
  const canDownloadAsPdf = isOnline && !isReviewRequired

  // display the text in the dropdown
  canPresent && actionsToUse.push('present')
  canDuplicate && actionsToUse.push('duplicate')
  canEdit && actionsToUse.push('edit')
  canDelete && actionsToUse.push('delete')
  canAddToFolder && actionsToUse.push('addToFolder')
  canDownloadAsPdf && actionsToUse.push('downloadAsPDF')

  const MenuItems = actions?.length || actionsToUse.length
    ? (actions ?? actionsToUse)
      .map(action => {
        const { onPress, ...rest } = customDeckContextOptions[action]
        return (
          <DNAContextMenu.Item
            disabled={ actions ? !actions.length : !actionsToUse.length}
            key={action}
            status={isDesktop ? 'neutral' : 'dark'}
            onPress={DNACustomDeckActions[action](customDeckORM, folderItemORM)}
            {...rest}
          />
        )
      })
    : (<DNAContextMenu.Item
        title="(No actions available)"
        onPress={() => {}}
    />)

  return (
    <DNAContextMenu>
      <DNAContextMenu.Anchor>
        { children }
      </DNAContextMenu.Anchor>
      <DNAContextMenu.Items>
        { MenuItems }
      </DNAContextMenu.Items>
    </DNAContextMenu>
  )
}

export default DNACustomDeckContextMenu
